"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BloxTextArea = exports.BloxLabel = exports.BloxInput = exports.BloxButton = exports.BloxAnchor = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Typography = require("../components/Typography");

var _PTTLayout = require("../components/PTTLayout");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var BloxButton = _styledComponents["default"].button.attrs(function (_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? '' : _ref$variant,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color;
  return {
    className: ['blox', variant, color].filter(Boolean).join(' ')
  };
}).withConfig({
  displayName: "native__BloxButton",
  componentId: "sc-1sxbunz-0"
})(["&&&{", " ", "}"], _Typography.Typography, _PTTLayout.Layout);

exports.BloxButton = BloxButton;

var BloxInput = _styledComponents["default"].input.attrs({
  className: 'blox hide-invalid'
}).withConfig({
  displayName: "native__BloxInput",
  componentId: "sc-1sxbunz-1"
})(["&&&&{", " ", "}"], _Typography.Typography, _PTTLayout.Layout);

exports.BloxInput = BloxInput;

var BloxLabel = _styledComponents["default"].label.attrs({
  className: 'blox'
}).withConfig({
  displayName: "native__BloxLabel",
  componentId: "sc-1sxbunz-2"
})(["&&&{", " ", "}"], _Typography.Typography, _PTTLayout.Layout);

exports.BloxLabel = BloxLabel;

var BloxAnchor = _styledComponents["default"].a.attrs(function (props) {
  return {
    className: "blox".concat(props.disabled ? ' disabled' : ''),
    href: props.disabled ? undefined : props.href,
    role: props.disabled && !props.role ? 'link' : props.role,
    // If disabled, role should be link if not specified
    'aria-disabled': props.disabled ? 'true' : undefined
  };
}).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'disabled';
  } // The disabled prop will no make it to the DOM

}).withConfig({
  displayName: "native__BloxAnchor",
  componentId: "sc-1sxbunz-3"
})(["&&&{", " ", "}"], _Typography.Typography, _PTTLayout.Layout);

exports.BloxAnchor = BloxAnchor;

var BloxTextArea = _styledComponents["default"].textarea.attrs({
  className: 'blox hide-invalid'
}).withConfig({
  displayName: "native__BloxTextArea",
  componentId: "sc-1sxbunz-4"
})(["&&&{", " ", "}"], _Typography.Typography, _PTTLayout.Layout);

exports.BloxTextArea = BloxTextArea;